// extracted by mini-css-extract-plugin
export default {"defaultContainer":"defaultContainer--s9QsF","small":"small--McI2Y","default":"default--J6H3W"};